import React from 'react';
import _ from 'lodash';
import { BrokerApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { daysAgo } from '../../common/SharedFunctions';
import { Accordion, SortableHeader } from '../../common/SharedComponents';
import { RefreshEvents } from '../../common/SharedEvents';
import store, { brokerActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlag } from '@fortawesome/free-solid-svg-icons';

const activeColumns = [
    { key: 'Name', label: 'Name', id: 'name' },
    { key: 'Flgd', label: 'Flag', id: 'isFlagged' },
    { key: 'Email', label: 'Email', id: 'emailAddress' },
    { key: 'Notes', label: 'Notes', id: 'rejectedComment' },
    { key: 'Modified', label: 'Modified', id: 'updatedAt' },
    {
        key: 'Point of Contact',
        label: 'Point of Contact',
        id: 'pointOfContact',
    },
];

const RejectedBrokerTable = () => {
    const searchState = useSelector((state) => state.searchState);
    const brokerApi = new BrokerApi.BrokerApi(applicationInsights);

    const { dispatch } = store;

    const refreshEvents = new RefreshEvents();

    const _handleRowClick = (row) => {
        dispatch(brokerActions.setBrokerId({ brokerId: row.id }));
        dispatch(brokerActions.setBrokerModalOpen({ openBrokerModal: true }));
    };

    const _loadBrokers = async () => {
        const response = await brokerApi.getRejectedBrokerGridRows();

        if (response.statusCode !== 200) return;

        set_rows(
            response.result.map((b) => ({
                ...b,
                name: b.lastName + ', ' + b.firstName,
                updatedDaysAgo: daysAgo(new Date(b.updatedAt)),
            }))
        );
    };

    const [rows, set_rows] = React.useState([]);
    const [sort, set_sort] = React.useState({
        column: 'updatedAt',
        direction: 'asc',
    });

    const matchName = (s) => s.name && s.name.toLowerCase().includes(searchState.searchText.broker.toLowerCase());
    const matchEmail = (s) =>
        s.emailAddress && s.emailAddress.toLowerCase().includes(searchState.searchText.broker.toLowerCase());

    const sortedRows = _.chain(rows)
        .filter((s) => !searchState.searchText.broker || matchName(s) || matchEmail(s))
        .orderBy(sort.column, sort.direction)
        .value();

    React.useEffect(() => {
        _loadBrokers();

        refreshEvents.addRefreshListener(_loadBrokers);
    }, []);

    return (
        <Accordion
            title='Rejected Brokers'
            isExpanded={false}
        >
            <div className='card'>
                <div className='card-section'>
                    <table className='no-status'>
                        <thead>
                            <tr>
                                {activeColumns.map((column) => (
                                    <SortableHeader
                                        key={column.key}
                                        column={column}
                                        sort={sort}
                                        onPress={set_sort}
                                    />
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {sortedRows.map((row) => (
                                <tr
                                    key={row.id}
                                    onClick={() => _handleRowClick(row)}
                                >
                                    <td className='primary'>{row.name}</td>
                                    <td className='isFlagged'>
                                        {row.isFlagged && (
                                            <i
                                                style={{ color: 'darkred' }}
                                                title='Broker is Flagged!'
                                            >
                                                <FontAwesomeIcon icon={faFlag} />
                                            </i>
                                        )}
                                    </td>
                                    <td>{row.emailAddress}</td>
                                    <td className='notes'>{row.rejectedComment}</td>
                                    <td className='time-stamp'>{row.updatedDaysAgo}</td>
                                    <td>{row.pointOfContact}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </Accordion>
    );
};

export default RejectedBrokerTable;
